import { render, staticRenderFns } from "./InstructorsTableInstructorKidSchoolCell.vue?vue&type=template&id=58fb6757&"
import script from "./InstructorsTableInstructorKidSchoolCell.vue?vue&type=script&lang=ts&"
export * from "./InstructorsTableInstructorKidSchoolCell.vue?vue&type=script&lang=ts&"
import style0 from "./InstructorsTableInstructorKidSchoolCell.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports